/**
 * WYSIWYG Image Toolbar Setup
 * Wires the per-image size/float popover into a Quill editor instance.
 */

import { WysiwygListener } from "../wysiwyg-listener";
import { WysiwygImageToolbarRender } from "./wysiwyg-image-toolbar-render";
import { WysiwygImageToolbarHandler } from "./wysiwyg-image-toolbar-handler";

interface QuillLike {
    root: HTMLElement;
}

export class WysiwygImageToolbarSetup {
    public static init(quill: QuillLike | null, editorDiv: HTMLElement | null, textarea: HTMLTextAreaElement | null): void {
        if (!quill || !(editorDiv instanceof HTMLElement) || !(textarea instanceof HTMLTextAreaElement)) {
            return;
        }

        if (editorDiv.dataset.wysiwygImageToolbarInitialized === "1") {
            return;
        }
        editorDiv.dataset.wysiwygImageToolbarInitialized = "1";

        const hostEl = editorDiv.parentElement ?? editorDiv;
        const popover = WysiwygImageToolbarRender.createPopover(hostEl);
        const handler = new WysiwygImageToolbarHandler(quill, hostEl, popover, textarea);

        WysiwygListener.bindImageToolbarInteractions(quill.root, popover, handler);
    }
}
